import { Box, styled, Typography, useTheme } from '@mui/material';
import React, { FC, Fragment, useContext, useEffect, useState } from 'react';
import { getRandomStringFromArr } from '../../../Utils/StringUtils';

// Define the interface for the component's props
interface CharBoxProps {
  index: number;
  row: number;
  correctChar: string;
  currentChar: string;
  winningPairs: string[];
  gameChars: string[];
}

// Functional Component using props and state
const CharBox: FC<CharBoxProps> = ({
  index,
  row,
  correctChar,
  currentChar,
  winningPairs,
  gameChars,
}) => {
  const theme = useTheme();
  //   const [currentChar, setCurrentChar] = useState(
  //     getRandomStringFromArr(gameChars)
  //   );
  const [isCorrectLetter, setIsCorrectLetter] = useState<boolean>(false);
  const [isCorrectPosition, setIsCorrectPosition] = useState(false);

  //   const onCharClickHandler = () => {
  //     setCurrentChar(getRandomStringFromArr(gameChars));
  //   };
  //   console.log('index::: ', index);
  //   //   console.log('row::: ', row);
  // console.log(
  // `'winningPairs.find(${currentChar}), ${currentChar}::: `,
  // winningPairs.findIndex((item) => item.includes(currentChar))
  // );

  // console.log(
  //   `test::: `,
  //   winningPairs.findIndex((item) => item.includes(currentChar)) === row
  // );

  useEffect(() => {
    currentChar && currentChar === correctChar
      ? setIsCorrectLetter(true)
      : setIsCorrectLetter(false);

    currentChar &&
    winningPairs.findIndex((item) => item.includes(currentChar)) === row
      ? setIsCorrectPosition(true)
      : setIsCorrectPosition(false);
  }, [currentChar]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      //   onClick={onCharClickHandler}
      sx={(theme) => ({
        height: '25%',
        width: 110,
        borderRadius: 2,
        border: `3px solid ${
          isCorrectLetter
            ? theme.palette.success.main
            : isCorrectPosition
              ? theme.palette.warning.main
              : //   : theme.palette.text.primary
                theme.palette.boxBorder?.main
        }`,
        fontSize: '3.25rem',
        // px: 8,
        color: isCorrectLetter
          ? theme.palette.success.main
          : isCorrectPosition
            ? theme.palette.warning.main
            : theme.palette.text.primary,
        cursor: 'pointer',
      })}
    >
      {/* {index + 1}  */}
      <ResponsiveText>{currentChar}</ResponsiveText>

      {/* <Typography variant="h4">({correctChar})</Typography> */}
    </Box>
  );
};

const ResponsiveText = styled(Typography)(({ theme }) => ({
  fontSize: '4rem', // Default
  [theme.breakpoints.down('md')]: {
    fontSize: '3rem', // Medium screen
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '2.5rem', // Small screen
  },
}));

export default CharBox;
